import { SlingoHTMLHelp } from "@lib/titan2-slingo/dist/game/view/abstract/display/SlingoHTMLHelp";
import { AppData } from "@lib/titan2/dist/game/AppData";
import { LanguageManager } from "@lib/titan2/dist/game/manager/LanguageManager";
/**
 * HTMLHelp.ts
 */
export class HTMLHelp extends SlingoHTMLHelp {
    createParams() {
        super.createParams();
        this.params.setValue("{param.game}", "Slingo Pawn Shop");
    }
    open() {
        super.open();
        this.handleSwiss();
    }
    handleSwiss() {
        if (this.shouldFilterAwaySwiss()) {
            this.filterElementsById("help.slingo.standard.swiss");
        }
    }
    shouldFilterAwaySwiss() {
        const locale = LanguageManager.getInstance().getLocale();
        return !["en-CH", "de-CH", "fr-CH", "it-CH"].includes(locale.getId());
    }
    addImages() {
        this.addColumn("help.slingo.standard.main.main", [this.createImage("logo.webp")], "300px");
        this.addColumn("help.slingo.standard.board.title", [this.createImage("Game-HelpPageWinLines.webp")], "10em");
        this.addColumn("help.slingo.standard.wild.title", [this.createImage("wild.webp")], "10em");
        this.addColumn("help.slingo.standard.scatter.title", [this.createImage("blocker.webp")], "10em");
        this.addColumn("help.slingo.standard.bonusspin.title", [this.createImage("plusSpin.webp")], "10em");
        this.addColumn("help.slingo.standard.superwild.title", [this.createImage("superWild.webp")], "10em");
        this.addColumn("help.goldfish.bonus.green.line2", [this.createImage("Game-prop_snuffbox_fatcat.png")], "10em", "10em");
    }
    addCustomHTML() {
        if (!this.shouldFilterAwaySwiss()) {
            this.createTable("help.slingo.standard.swiss.title", "help.slingo.standard.swiss", []);
        }
        this.createTable("help.goldfish.bonus.goldawards.title", "help.goldfish.bonus.goldawards", [
            { img: this.createImage("Game-prop_tuna.png"), key: "help.goldfish.bonus.goldawards.col1.row1", maxHeight: "75px", maxWidth: "75px" },
            { img: this.createImage("Game-prop_hairclip.png"), key: "help.goldfish.bonus.goldawards.col1.row2", maxHeight: "75px", maxWidth: "75px" },
            { img: this.createImage("Game-prop_snuffbox_fatcat.png"), key: "help.goldfish.bonus.goldawards.col1.row3", maxHeight: "75px", maxWidth: "75px" },
            { img: this.createImage("Game-prop_watch.png"), key: "help.goldfish.bonus.goldawards.col1.row4", maxHeight: "75px", maxWidth: "75px" },
        ]);
        this.createTable("help.goldfish.bonus.fishfoodawards.title", "help.goldfish.bonus.fishfoodawards", [
            { img: this.createImage("Game-prop_necklace.png"), key: "help.goldfish.bonus.fishfoodawards.col1.row2", maxHeight: "75px", maxWidth: "75px" },
            { img: this.createImage("Game-prop_watch.png"), key: "help.goldfish.bonus.fishfoodawards.col1.row3", maxHeight: "75px", maxWidth: "75px" },
            { img: this.createImage("Game-prop_hairclip.png"), key: "help.goldfish.bonus.fishfoodawards.col1.row4", maxHeight: "75px", maxWidth: "75px" },
            { img: this.createImage("Game-prop_tuna.png"), key: "help.goldfish.bonus.fishfoodawards.col1.row5", maxHeight: "75px", maxWidth: "75px" },
            { img: this.createImage("Game-prop_snuffbox_fatcat.png"), key: "help.goldfish.bonus.fishfoodawards.col1.row6", maxHeight: "75px", maxWidth: "75px" },
        ]);
        this.createTable("help.goldfish.max.min.title", "help.goldfish.max.min", []);
    }
    createTable(insertAfterKey, dataKeyPrefix, imageData) {
        const tableKeys = this.language.getKeys().filter(key => key.startsWith(`${dataKeyPrefix}.col`));
        const table = document.createElement("table");
        table.className = "help-table";
        const columns = new Set();
        const rows = new Set();
        for (const key of tableKeys) {
            const match = key.matchAll(/col(\d).+row(\d)/g).next();
            const column = match.value[1];
            const row = match.value[2];
            rows.add(row);
            columns.add(column);
        }
        if (!columns.has("1")) {
            columns.add("1");
        }
        if (!rows.has("1")) {
            rows.add("1");
        }
        const rowsArray = Array.from(rows);
        rowsArray.sort((a, b) => parseInt(a) - parseInt(b));
        const columnsArray = Array.from(columns);
        columnsArray.sort((a, b) => parseInt(a) - parseInt(b));
        rowsArray.map(row => {
            const tr = document.createElement("tr");
            const tds = columnsArray.map(column => {
                const td = document.createElement("td");
                td.id = `${dataKeyPrefix}.col${column}.row${row}.cell`;
                if (this.language.containsKey(`${dataKeyPrefix}.col${column}.row${row}`)) {
                    const span = document.createElement("span");
                    span.id = `${dataKeyPrefix}.col${column}.row${row}`;
                    span.innerHTML = this.language.getValue(`${dataKeyPrefix}.col${column}.row${row}`);
                    span.className = "help-span";
                    td.append(span);
                }
                return td;
            });
            tr.append(...tds);
            table.append(tr);
        });
        this.replaceTableElementsWithImages(table, imageData);
        this.addCustomHTMLSnippet(insertAfterKey, table.outerHTML);
    }
    replaceTableElementsWithImages(table, imageData) {
        const path = AppData.VERSION + "/help/help-assets/";
        imageData.forEach(({ img, key, maxWidth, maxHeight }) => {
            const imgElement = document.createElement("img");
            imgElement.src = `${path}${img.src}`;
            imgElement.id = `${key}.img`;
            this.applyMax(imgElement, maxWidth, maxHeight);
            const target = table.querySelector(`#${CSS.escape(key)}`);
            target.id = `${key}*`; // change the key to something not in the lang files or it will get replaced with the lang text.
            target.innerHTML = "";
            target.append(imgElement);
        });
    }
}
//# sourceMappingURL=HTMLHelp.js.map